import { CustomModal, CustomTag } from '@amili-v3/amili-v3-design';
import styled from 'styled-components';
import { FilterBody } from '../styles';

export const StatusWrapper = styled(CustomTag)`
  .ant-tag.custom-tag {
    border-radius: 8px !important;
  }
`;

export const SampleKitsCheckboxModal = styled(CustomModal)`
  .ant-modal-body {
    min-height: 200px;
    padding: 20px 40px 0px;
    margin-bottom: 10px;
    .sample-kits-checkbox-group {
      gap: 8px;
      display: flex;
      justify-content: space-between;
    }
  }
`;

export const SampleKitFilterBody = styled(FilterBody)`
  .analysis-sample-kit-filter-form {
    .fastQc-select > div {
      gap: 6px;
    }
    .has-profile-checkbox {
      font-weight: 600;
      color: var(--color);
    }
  }
`;
